import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryPrepareIcon from '../../../assets/new_gems/Category/GemCategoryPrepare.svg?inline';
export const GemCategoryPrepare = (props) => {
    return _jsx("img", { ...props, src: gemCategoryPrepareIcon, alt: 'GemCategoryPrepareImage' });
};
